export default function Team() {
  const team = [
    {
      name: 'Sarah Mitchell',
      role: 'CEO & Co-Founder',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20business%20executive%20in%20modern%20office%20wearing%20elegant%20business%20attire%2C%20confident%20smile%2C%20natural%20lighting%2C%20contemporary%20corporate%20headshot%2C%20warm%20professional%20atmosphere%2C%20clean%20simple%20background%2C%20approachable%20leadership%20presence%2C%20high%20quality%20portrait%20photography&width=400&height=500&seq=team-ceo-female-01&orientation=portrait',
      bio: 'Former VP of Customer Success at a Fortune 500 SaaS company with 15 years of experience scaling support operations.'
    },
    {
      name: 'David Chen',
      role: 'CTO & Co-Founder',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20technology%20executive%20in%20modern%20office%20wearing%20smart%20casual%20business%20attire%2C%20friendly%20confident%20expression%2C%20natural%20lighting%2C%20contemporary%20corporate%20headshot%2C%20innovative%20tech%20leader%20atmosphere%2C%20clean%20simple%20background%2C%20approachable%20demeanor%2C%20high%20quality%20portrait%20photography&width=400&height=500&seq=team-cto-male-01&orientation=portrait',
      bio: 'AI researcher and engineer with a PhD in Machine Learning. Previously led AI initiatives at leading tech companies.'
    },
    {
      name: 'Emily Rodriguez',
      role: 'Head of Product',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20product%20manager%20in%20modern%20office%20wearing%20contemporary%20business%20casual%20attire%2C%20warm%20smile%2C%20natural%20lighting%2C%20corporate%20headshot%2C%20creative%20innovative%20atmosphere%2C%20clean%20simple%20background%2C%20collaborative%20leadership%20presence%2C%20high%20quality%20portrait%20photography&width=400&height=500&seq=team-product-female-01&orientation=portrait',
      bio: 'Product leader with 10+ years building customer-facing tools. Passionate about creating intuitive AI experiences.'
    },
    {
      name: 'Marcus Johnson',
      role: 'Head of Customer Success',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20customer%20success%20executive%20in%20modern%20office%20wearing%20business%20casual%20attire%2C%20genuine%20friendly%20smile%2C%20natural%20lighting%2C%20contemporary%20corporate%20headshot%2C%20supportive%20approachable%20atmosphere%2C%20clean%20simple%20background%2C%20customer%20focused%20presence%2C%20high%20quality%20portrait%20photography&width=400&height=500&seq=team-success-male-01&orientation=portrait',
      bio: 'Customer success expert who ensures our clients achieve maximum value from our AI agents. Former support team leader.'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-[#F8F8F8]">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#B8985F]/40 bg-[#B8985F]/10 mb-6">
            <i className="ri-group-line text-[#B8985F] text-sm w-4 h-4 flex items-center justify-center"></i>
            <span className="text-[13px] text-[#B8985F] font-medium">Our Team</span>
          </div>
          <h2 className="text-[36px] md:text-[42px] font-bold text-black leading-[1.2] mb-6">
            Meet the People Behind EasyMarketPro
          </h2>
          <p className="text-[16px] md:text-[18px] text-[#555] max-w-[700px] mx-auto">
            A diverse team of AI experts, support veterans, and product innovators working together to transform customer support.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {team.map((member, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all"
            >
              <div className="w-full h-[280px]">
                <img
                  src={member.image}
                  alt={`${member.name} - ${member.role}`}
                  title={`${member.name} - EasyMarketPro ${member.role}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <h3 className="text-[18px] md:text-[20px] font-bold text-black mb-1">
                  {member.name}
                </h3>
                <p className="text-[13px] text-[#B8985F] font-medium mb-3">
                  {member.role}
                </p>
                <p className="text-[13px] md:text-[14px] text-[#555] leading-[1.6]">
                  {member.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
